export default __webpack_public_path__ + "static/carbon-calculator-df9c512666082f4e2d2af356774f669c.svg";